import { AdjustedLine, ModifierContext } from "../../modifier-models";
import { BaseRule } from "../../rule-base";

export class RulePhysio0009 extends BaseRule {
    name = 'Physio 0009: Full fee for additional condition';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0009') return;

        if (autoApply) {
            // Multiple conditions requiring individual treatment - charged as individual treatments
            // Full details of treatments and diagnostic codes must be stated
            line.trace.push('Physio 0009: Multiple conditions requiring individual treatment - charged as individual treatments');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0009',
                message: 'Multiple conditions requiring individual treatment - charged as individual treatments. Full details of treatments and diagnostic codes must be stated.',
                kind: 'overwrite',
                unitsDelta: line.adjustedUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines.forEach(line => {
            if (line.code === '0009') {
                // Multiple conditions requiring individual treatment
                line.trace.push('Physio 0009: Multiple conditions requiring individual treatment - charged as individual treatments');
            }
        });
        return lines;
    }
} 